import React, {Component} from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import IdleTimer from 'react-idle-timer'
import VideoScore from './VideoScore';
import FinalQuiz from './FinalQuiz';
import VideoDiscussion from "./VideoDiscussion";
import VideoQuestionSummary from "./VideoQuestionSummary";
import VideoPlayer from './VideoPlayer';
import VideoQuestion from './VideoQuestion';
import send from '../../utils/ChatServer.js';
import correctSound from '../../assets/audio/ding.WAV';
import {NotificationManager} from 'react-notifications';
import moment from 'moment';
import IdleModal from './IdleModal';

import LectureTimer from './LectureTimer';
// Audios
import successAudio from '../../assets/audio/appointed.mp3';
import errorAudio from '../../assets/audio/unsure.mp3';
import completeAudio from '../../assets/audio/happy-ending.mp3';
import "video-react/dist/video-react.css";

/* global $ */

const defaultState = {
    requiredComponents: {
        questions: false,
        quiz: false,
        video: true
    },
    completedComponents: {
        questions: false,
        quiz: false,
        video: false
    },
    count: 0,
    videoId: null,
    showQuiz: false,
    showSummaryAndStuff: true,
    showNextVideo: false,
    markedShowQuiz: false,
    markedNext: false,

    nextChapterPart: {},
    frameQuestions: [],
    finishedSubject: false,
    completed: false,
    loaded: false,
    idleModal: false,
}

class VideoItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            requiredComponents: {
                questions: false,
                quiz: false,
                video: true
            },
            completedComponents: {
                questions: false,
                quiz: false,
                video: false
            },
            count: 0,
            videoId: null,
            showQuiz: false,
            showSummaryAndStuff: true,
            showNextVideo: false,
            markedShowQuiz: false,
            markedNext: false,
            nextChapterPart: {},
            frameQuestions: [],
            finishedSubject: false,
            completed: false,
            loaded: false,
            showingScore: false,
            idleModal: false,
        };
        
        this.videoContainer = React.createRef();
        this.question = React.createRef();
        this.timer = React.createRef();
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)


    }

    _onAction(e) {

      }
     
    _onActive(e) {

    }
    
    _onIdle(e) {

    if(this.videoContainer.current){
        if(this.videoContainer.current.state.player){
            if(this.videoContainer.current.state.player.paused || this.videoContainer.current.state.player.ended){
                this.setState({idleModal: true});
            }
        }
    }
    }

    renderNextVideoTile = () => {

        if(this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active).length > 0){

            let part = this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active)[0];
        
            if(part && this.state.showNextVideo && this.state.loaded && !this.state.showingScore){
                this.setState({showingScore: true});
                return (
                    <VideoScore
                            completedIn={part.userTime}
                            videoTime={part.duration}
                            efficiency={part.efficiency}
                            attentiveness={part.attentiveness}
                            quiz={this.props.userLecture.Lecture.QuizQuestions.length > 0 ? part.quiz : -1}
                            completion={part.completion}
                            completedPoints={part.points.completed}
                            efficiencyPoints={part.points.efficiency}
                            attentivenessPoints={part.points.attentiveness}
                            quizPoints={part.points.quiz}
                            completionPoints={part.points.completion}
                            totalPoints={this.props.courseUser[0].points - part.totalPoints}
                            profile={this.props.profile}
                            courseUser={this.props.courseUser[0]}
                            user={this.props.user}
                            feedbackPrompt={this.props.chapterPart.feedbackPrompt || false}
                            onContinue={e => {
                                e.preventDefault();
                                let ncp = this.props.courseUser[0].nextChapterPart;
                                this.setState({
                                requiredComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: true
                                },
                                completedComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: false
                                },
                                count: 0,
                                videoId: null,
                                showQuiz: false,
                                showSummaryAndStuff: true,
                                showNextVideo: false,
                                markedShowQuiz: false,
                                markedNext: false,
                                nextChapterPart: {},
                                frameQuestions: [],
                                finishedSubject: false,
                                completed: false,
                                loaded: false,
                                showingScore: false,
                                idleModal: false,
                                }, () =>{
                                    let self = this;
                                        if(self.state.finishedSubject){
                                            self.props.history.push('/dashboard');
                                        }else{
                                                if(ncp.type == "test"){
                                                self.props.history.push('/subject-test/' + ncp.id)
                                            }else{
                                                self.props.history.push('/video/item/' + ncp.id)
                                            } 
                                        }
                                    
                                    
                                }) 
                                
                            }}
                            continueLink={(<Link to="#nogo" onClick={e => {
                                e.preventDefault();
                                let ncp = this.props.courseUser[0].nextChapterPart;
                                this.setState({
                                requiredComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: true
                                },
                                completedComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: false
                                },
                                count: 0,
                                videoId: null,
                                showQuiz: false,
                                showSummaryAndStuff: true,
                                showNextVideo: false,
                                markedShowQuiz: false,
                                markedNext: false,
                                nextChapterPart: {},
                                frameQuestions: [],
                                finishedSubject: false,
                                completed: false,
                                loaded: false,
                                showingScore: false,
                                idleModal: false,
                                }, () =>{
                                    let self = this;
                                        if(self.state.finishedSubject){
                                            self.props.history.push('/dashboard');
                                        }else{
                                                if(ncp.type == "test"){
                                                self.props.history.push('/subject-test/' + ncp.id)
                                            }else{
                                                self.props.history.push('/video/item/' + ncp.id)
                                            } 
                                        }
                                    
                                    
                                }) 
                                
                            }} className="btn btn-primary" style={{margin: '60px'}}>Continue <i className="zmdi zmdi-arrow-right" /></Link>)}
                        />
                    )

                
            
            }
        }else{
            
            return null
        }
    } 
    
    updateVideoQuestion = (question, token) => {
        if(question){
            if(this.props.profile.role === "student" && this.props.videoQuestions.filter(q => q.id === question.id && q.complete).length === 0){
                
                this.props.updateVideoQuestion(question, token);
            }else if(this.props.profile.role !== "student"){
                this.props.fakeUpdateQuestion(question);
            }
        }
    }

    componentDidMount() {
        /*
        if(this.props.profile.role === 'admin'){
            //this.props.onAdminLoad(this.props.match.params.id, this.props.user.id, this.props.user.user.Profile.id, this.props.user.userId);
            
        }else{
            this.props.onLoad(this.props.match.params.id, this.props.user.id, this.props.courseUser[0], this.props.courseUser[0].subjectAttempt, this.props.courseUser[0].courseAttempt, this.props.userSubject, this.props.user.user.Profile.id, this.props.user.userId);
        
        }
        */
       if(this.props.match.path === '/video/:courseId/:subjectId/:id'){
            this.props.onLoad(this.props.match.params.id, this.props.profile.id, this.props.user.id);
       }else{
            this.props.onLoad(this.props.match.params.id, this.props.profile.id, this.props.user.id);
        }
        
        //this.setVideoId(this.props.match.params.id);
    }
    
    initialize = (oldProps, oldState) => {

        if(this.props.chapterPart.VideoFile){
            if(!this.state.loaded){
                this.setState({loaded: true}, () => {
                    setTimeout(function(){
                        try{
                            $("#quizTabs").find('a')[0].click();
                            $(".tab_pane")[0].toggle('tab');
                        }catch(err){
                            //// console.log("Couldn't activate tab 1", err);
                        }
                    }, 1000);
                   
                let alreadyCompleted = this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active);
                if(alreadyCompleted.length == 0) {
                    // If user hasn't completed yet, but have partially watched the vide, we start them where they left off

                        let courseUser = this.props.courseUser[0];
                        let completed = this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active);
                        if (completed.length === 0) {
                            let defaultTime = 0;
                            let self = this;

                            // Set study time counter to pick up where student left off
                            if (courseUser.currentUserTime > this.state.userTime) {
                                if (courseUser.currentUserTime) {
                                    this.setState({userTime: courseUser.currentUserTime});
                                }
                            }
                        }
                        
                        // If they are midway through we need to skip certain video questions
                        if (this.props.userLecture.currentTime) {

                            if(this.props.userLecture.Lecture.VideoFile[0].duration){
                                if(this.props.userLecture.currentTime >= this.props.userLecture.Lecture.VideoFile[0].duration){

                                }else{
                                    let skipCounts = 0;
                                    this.props.chapterPart.VideoQuestions.filter(q => {
                                        if (q.time < this.props.userLecture.currentTime) {
                                            skipCounts += 1;
                                        }
                                    });
                                    if(skipCounts === this.props.chapterPart.VideoQuestions.length && skipCounts > 0){
                                        let {completedComponents} = this.state;
                                        let newComponents = {
                                            ...completedComponents,
                                            questions: true
                                        }

                                        this.setState({completedComponents: newComponents});
                                    }

                                    if(skipCounts > this.state.count){
                                        this.setState({count: skipCounts});
                                    }
                                }

                            }
                        }
                    
                    
                }else{
                    //this.setState({completed: true});
                }
            });
        }
        }
    }

    componentDidUpdate(props, state){
        if(this.props.match.path === '/video/item/:id'){

        }
        

        if(this.props.courseUser[0].id && props.courseUser[0].id){
            if(this.props.courseUser[0].currentSubject !== props.courseUser[0].currentSubject && !this.state.finishedSubject){
                this.setState({finishedSubject: true});
            }else if(this.props.courseUser[0].courseCompleted && !props.courseUser[0].courseCompleted && !this.state.finishedSubject){
                this.setState({finishedSubject: true});
            }
        }

        if(JSON.stringify(this.state.completedComponents) != JSON.stringify(state.completedComponents)){
            const {completedComponents, requiredComponents} = this.state;

            let completedComponentCount = 0;
            let requiredComponentCount = 0;
            Object.keys(requiredComponents).map((c, i) => {
                if(requiredComponents[c] === true){
                    requiredComponentCount += 1;
                }
            });

            Object.keys(completedComponents).map((c, i) => {
                if(completedComponents[c] === true){
                    completedComponentCount += 1;
                }
            })


            // They've finished something.  Check if completed length equals required length
            if(requiredComponentCount === completedComponentCount && completedComponents.video === true){
                // Finished everything
                if(!this.state.completed){
                    this.setState({completed: true, loaded: true}, () => {
                        this.updateCourseUserNextVideo();
                    })
                }
                
            }else if(requiredComponents.quiz === true && completedComponents.quiz === false && completedComponents.video === true){
                // Navigate to quiz

                if(!this.state.markedShowQuiz) {
                    this.setState({markedShowQuiz: true, showQuiz: true}, () => {
                        NotificationManager.success('To proceed, please take the final test for this lecture.', 'Awesome job finishing this lecture!');
                        $('[href="#final_quiz"]').tab('show');

                        
                        let {currentLog} = this.props;
                        if(currentLog){
                            currentLog.end = new Date();
                            this.props.updateLog(currentLog, this.props.user.id);
                        }
                        let newLog = {
                            date: new Date(),
                            duration: 0,
                            type: 'Lecture',
                            subjectId: this.props.chapterPart.subjectId,
                            chapterId: this.props.chapterPart.subjectChapterId,
                            chapterVideoId: this.props.chapterPart.id,
                            activity: 'Quiz',
                            score: 'NA',
                            courseUserId: this.props.courseUser[0].id,
                            userId: this.props.user.user.id
                        }

                        this.props.createLog(newLog, this.props.user.id);
                        window.scroll({
                            top: document.getElementsByClassName('nav-tabs-custom')[0].scrollHeight, 
                            left: 0, 
                            behavior: 'smooth' 
                        });
                    });
                }
            }else{
                //// console.log("Not sure what to do now");
            }
        }else{
           // // console.log("updated with no change to completed components");
        }

        if(this.props.match.params.id != props.match.params.id){
            if(this.props.profile.role === 'admin'){
                this.props.onAdminLoad(this.props.match.params.id, this.props.user.id, this.props.user.user.Profile.id, this.props.user.userId);
            }else{

                
                this.props.onLoad(this.props.match.params.id, this.props.profile.id, this.props.user.id);
            }
            this.setState({
                requiredComponents: {
                    questions: false,
                    quiz: false,
                    video: true
                },
                completedComponents: {
                    questions: false,
                    quiz: false,
                    video: false
                },
                count: 0,
                videoId: null,
                showQuiz: false,
                showSummaryAndStuff: true,
                showNextVideo: false,
                markedShowQuiz: false,
                markedNext: false,
            
                nextChapterPart: {},
                frameQuestions: [],
                finishedSubject: false,
                completed: false,
                loaded: false,
                showingScore: false,
                idleModal: false,
            })
            //$("#quizTabs").find('li')[0].find('a')[0].trigger('click');
        }
        
        // Set video id
        if(!this.state.videoId && this.props.socket){
            if(this.props.socket.readyState == 1){
                this.setVideoId(this.props.match.params.id, this.props.socket);
            }
        }

        if(this.props.chapterPart !== props.chapterPart && this.props.chapterPart.id){
            const {requiredComponents} = this.state;
            let nc = {
                ...requiredComponents
            }
            if(this.props.chapterPart.VideoQuestions.length > 0){
                nc.questions = true;
            }

            if(this.props.chapterPart.QuizQuestions.length > 0){
                nc.quiz = true;
            }

            this.setState({requiredComponents: nc});
        }

        
        
        // Check if done quiz
        if(this.props.quiz.correctPercent && this.props.testScored === true){
            let results = this.props.quiz;
            if(results.correctPercent < 80){
                return false;
            }else{
                this.onQuizComplete();
                
            }
        }else if(props.testScored && !this.props.testScored){
            let {completedComponents} = this.state;
            let nc = {
                ...completedComponents,
                quiz: false
            };

            this.setState({completedComponents: nc});
        }

        if(this.props.courseUser[0]){
            if(this.props.courseUser[0].currentSubject !== props.courseUser[0].currentSubject && props.courseUser[0].currentSubject && this.props.courseUser[0].currentSubject){
                this.setState({finishedSubject: true});
            }
        }
        
        // Old shownext
        if(this.videoContainer.current){
            if(this.props.userLecture){
                if(props.userLecture){
                    if(this.props.userLecture.completed && !props.userLecture.completed && !this.state.showNextVideo){
                        if(this.props.courseUser[0]){
                            if(this.props.courseUser[0].currentSubject !== props.courseUser[0].currentSubject){
                                this.setState({finishedSubject: true});
                            }
                            if(this.props.courseUser[0].nextChapterPart && props.courseUser[0].nextChapterPart){
                                if(this.props.courseUser[0].nextChapterPart.id != props.courseUser[0].nextChapterPart.id && this.state.markedNext){
                                    this.setState({showNextVideo: true, nextChapterPart: this.props.courseUser[0].nextChapterPart});
                                }
                            }
                        }
                    }
                }
            }
        }


        if(this.props.courseUser[0].id && props.profile.role === "student"){
            if(this.props.chapterPart.id !== props.chapterPart.id || (this.props.chapterPart.id && !this.state.loaded)){
                this.initialize(props, state);
                let {currentLog} = this.props;
                if(currentLog){
                    currentLog.end = new Date();
                    this.props.updateLog(currentLog, this.props.user.id);
                }

                let newLog = {
                    date: new Date(),
                    duration: 0,
                    type: 'Lecture',
                    subjectId: this.props.chapterPart.subjectId,
                    chapterId: this.props.chapterPart.subjectChapterId,
                    chapterVideoId: this.props.chapterPart.id,
                    activity: 'Video',
                    score: 'NA',
                    courseUserId: this.props.courseUser[0].id,
                    userId: this.props.user.user.id
                }

                this.props.createLog(newLog, this.props.user.id);
            }
        }
        
        
    }

    setVideoId = (videoId, socket) => {
        let setted = false;
        let self = this;
        
     
        if(socket){
            self.setState({videoId: true}, () => {
                send({type: 'SET_VIDEO', videoId: videoId, id: self.props.profile.id}, socket, self.props.user.id);
                setted = true;    
            })
            
        }
            
        
    }

    getCurrentDuration = () => {
        if(this.videoContainer.current){
            return this.videoContainer.current.state.duration;
        }else{
            return -1;
        }
    }

    
    syncTaskProgress = () => {

        this.props.tasks.map(t => {
            if(moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0){
                let taskIndex = t.value.map(v => v.value);
                let realIndex = taskIndex.indexOf(this.props.chapterPart.id);
                let relevantTask = false;
                let duration = this.videoContainer.current.state.duration;
                let cs = this.videoContainer.current.state.currentSeconds;
                if(t.value.length === 1){
                    // Should just mark progress percentage of through video
                    if(t.value[0].value === this.props.chapterPart.id){
                        relevantTask = true;
                        if(t.progress < 99){
                            if(Math.ceil((cs / duration) * 100) > t.progress){
                                t.progress = Math.ceil((cs / duration) * 100) > 90 ? 90 : Math.ceil((cs / duration) * 100); 
                            }
                        }
                    }
                }else{
                    if(t.value[realIndex]){
                        if(t.value[realIndex].value === this.props.chapterPart.id){
                            relevantTask = true;
                            if(t.progress < 99){
                            // This task has multiple items and is more complex..
                                t.value[realIndex].progress = Math.ceil((this.state.userTime / duration) * 100) > 90 ? 90 : Math.ceil((this.state.userTime / duration) * 100);
                            }
                            
                            // calculate total task progress as 100 / length
                            let totalValue = 100 * t.value.length;
                            let actualValue = 0;
                            t.value.map(v => {
                                actualValue += v.progress;
                            })
                            t.progress = Math.ceil((actualValue / totalValue) * 100);
                        }
                    }
                }
                if(relevantTask){
                
                    
                    let data = {
                        type: 'UPDATE_TASK',
                        task: t,
                        token: this.props.user.id
                    };
                    let self = this;
                    setTimeout(function(){
                        try{
                           send(data, self.props.socket, self.props.user.id); 
                            
                        }catch(err){
                        }
                    }, 500);
                }
            }
            
        })
    }

    setThrowback = () => {
        let self = this;
        let question = null;
        if(this.state.frameQuestions.length > 0){
            question = JSON.parse(JSON.stringify(this.state.frameQuestions[0]));
        }
        this.setState({frameQuestions: []}, () => {
            if(self.videoContainer){
                if(question){
                    self.videoContainer.current.seekTo(question.answerAt);
                    self.question.current.hideModal();
                    setTimeout(function(){
                        self.videoContainer.current.play();
                    }, 500);
                
                }
            }
        });     
    }
    
    setThrowforward = () => {
        let self = this;
        this.setState({frameQuestions: [], count: this.state.count + 1}, () => {
            if(self.videoContainer){  
                self.question.current.hideModal();
                self.videoContainer.current.play();
            } 
        });
    }


    updateCourseUserCurrentTime = () => {
        let courseUser = this.props.courseUser[0];
        let completed = this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active);

        if(completed.length === 0){

            let currentTime = this.videoContainer.current.state.currentTime;


            if(currentTime.indexOf(":") > -1){
                let splitTime = currentTime.split(":");
                let minutes = parseInt(splitTime[0]) * 60;
                let seconds = parseInt(splitTime[1]);

                currentTime = minutes + seconds;

            }
            courseUser.currentPartVideoTime = currentTime;
            courseUser.currentUserTime = this.state.userTime;
            courseUser.currentVideoTime = this.videoContainer.current.state.duration;

            this.props.nextChapterPart(courseUser, this.props.user.id);
        }

    }

    updateCourseUserNextVideo = () => {
        if(this.props.chapterPart.QuizQuestions){
            if(this.props.chapterPart.QuizQuestions.length > 0 && !this.props.quiz.correctPercent){
                return false;
            }
        }
        
        if(this.props.quiz.id){
            if(this.props.quiz.correctPercent < 80){
                return false;
            }
        }
        
        if(!this.videoContainer.current){
            return false;
        }
        
        if(this.props.profile.role !== "student"){
            return false;
        }
        
        if(this.state.markedNext == false && this.videoContainer.current.state.currentSeconds > 10) {
            this.setState({markedNext: true, showNextVideo: true}, e => {
                let courseUser = this.props.courseUser[0];
                let userLecture = this.props.userLecture;

                let alreadyCompleted = userLecture.completed;
                // Check if part of a task, if so, set index, and progress percent:
                let task = null;
                
                this.props.tasks.map(t => {
                    let taskIndex = t.value.map(v => v.value);
                    let realIndex = taskIndex.indexOf(this.props.chapterPart.id);
                    if(realIndex >= t.currentIndex){
 
                        // So we should set new index to +1 
                        if(t.value.length > 1){
                            t.currentIndex++;
                            t.progress = parseInt((t.currentIndex / t.value.length) * 100);
                        }else{
                            t.progress = 100;
                        }
                        
                        if(realIndex){
                            if(t.value[realIndex]){
                                t.value[realIndex].progress = 100;
                            }
                        }
                        
                        let data = {
                            type: 'UPDATE_TASK',
                            task: t,
                            token: this.props.user.id
                        };
                        let self = this;
                        setTimeout(function(){
                            try{
                               send(data, self.props.socket, self.props.user.id); 
                                
                            }catch(err){
                            }
                        }, 1000);
                        
                    }
                })
                
                if(alreadyCompleted){

                    // If a user does this video again, and gets different results, should we update the courseUser object with
                    // the updated chapterPart results?

                    // 2019-04-04
                    // This issue has been solved.  Initially, fields like currnet user time, current part, etc. was all stored in the 
                    // CourseUser object.
                    // And when the user would finish a lecture, information about the completed lecture was stored as 
                    // CourseUser.completedChapterParts = [... {completed part}]

                    // We've since moved to user UserLecture objects to hold information about the users instance of a lecture,
                    // including storing their current position in the video, and tying all userVideoQuestions and Quiz to the userLecture object.
                    // So now, when they complete a userLecture, we simply update the UserLecture object with the points they've gained from the lecture,
                    // as well as marking completed=true in the UserLecture.

                    // Initially, we figured storing course progress in the CourseUser object directly was a quick and easy method to accomplish what we
                    // were trying to do.  The scope then expanded, and we wanted the user to be able to go back and rewatch videos, and then store
                    // that current position as well for every video, and also wanted to preserve data in the event of the user retaking the lecture.
                    // 
                    // Initially, when a user were to fail a lecture, we'd hard-delete their userVideoQuestions, and not store their entire attempt
                    // because we only had the ability to store completedChapterParts, and it wouldn't be completed if they failed it.

                    // Now, when a lecture loads, it looks for a userLecture for this current user where subjectAttempt == cu.subjectAttempt && active==true.
                    // If a user completes a lecture, we leave it as active=true, but we just set the completed=true as well, so that their last completed userLecture
                    // will be the one used if they go back to rewatch the lecture at a later date.

                    // Now, if they fail the entire subject, and need to retake it, we will set cu.subjectAttempt += 1, so that way, when they come back to
                    // this lecture in the future, on a new subject attempt, it will forcefully create a new instance of this userLecture,
                    // while still preserving their old data, for statistic and analytic reasons.

                    // If I were to go back to the beginning of this project, knowing what I know now in how the app should work (there were a lot of grey areas)
                    // I would have used this UserLecture method over the old CompletedChapterParts method from the get-go.

                    // Live and learn.

                    // Planning should always have serious consideration in these technique-related things/

                    // N
                }else {

                    /*
                    // Configure object to save as CompletedChapterPart
                    let part = this.props.chapterPart;
                    */

                    // Configure userLecture object with new data:
                    let userLecture = this.props.userLecture;
                    let finish = (this.props.chapterPart.finish) ? this.props.chapterPart.finish : this.videoContainer.current.state.duration;
                    let part = {
                        ...userLecture,
                        completedOn: new Date(),
                        duration: this.videoContainer.current.state.duration,
                        currentTime: 0,
                        userTime: this.timer.current ? this.timer.current.state.userTime : userLecture.userTime,
                        points: {
                            quiz: 0,
                            attentiveness: 0,
                            efficiency: 0,
                            completion: 0
                        },
                        totalPoints: 0,
                        title: this.props.chapterPart.title,
                        discussion: 0
                        
                    }
                                       
                    
                    // Add time to current date.
                    // Find existing current date:
                    let today = moment();


                    // Add merits based on discussion participation
                    let answeredDiscussion = 0;

                    this.props.discussion.map(d => {
                        let comments = d.DiscussionComment.filter(c => c.profileId == this.props.profile.id);
                        if(comments.length > 0){
                            answeredDiscussion += 1;
                        }
                    })

                    if(answeredDiscussion > 0){
                        part.discussion = answeredDiscussion;
                    }

                    let createEfficiencyNotification = false;
                    let efficiency = 100;
                    if(finish){
                        efficiency = Math.ceil((finish / part.userTime) * 100);
                        if(efficiency > 300){
                            efficiency = 300;
                        }else if(efficiency < -300){
                            efficiency = -300;
                        }
                        if(efficiency >= 90){
                            createEfficiencyNotification = true;
                        }
                    }else{
                        createEfficiencyNotification = true;
                    }

                    part.efficiency = efficiency;

                    if(part.VideoQuestions.length === 0){
                        part.attentiveness = 100;
                    }else{
                        let attentiveness = 0;
                        let attentiveQuestions = this.props.videoQuestions.filter(q => q.correct === true && q.attempts < 2);

                        attentiveness = Math.ceil((attentiveQuestions.length / this.props.videoQuestions.length) * 100);
                       part.attentiveness = attentiveness;
                    }
                    try {
                        if (efficiency >= 100) {
                            let note = {
                                profileId: this.props.profile.id,
                                courseId: courseUser.courseId,
                                mine: true,
                                content: "Woah!  You were " + efficiency.toString() + "% efficient in your last lecture. #mindblown",
                                show: (this.props.profile.settings.shareScore) ? true : false
                            }

                            this.props.createCourseNotification(note, this.props.user.id);

                        } else if (efficiency >= 90) {
                            let note = {
                                profileId: this.props.profile.id,
                                courseId: courseUser.courseId,
                                content: "Congratulations! You've just reached " + efficiency.toString() + "% efficiency in your last lecture. Keep going :D",
                                mine: true,
                                show: (this.props.profile.settings.shareScore) ? true : false
                            }

                            this.props.createCourseNotification(note, this.props.user.id);
                        }

                        
                        
                        if (part.attentiveness >= 90) {
                            let note = {
                                profileId: this.props.profile.id,
                                courseId: courseUser.courseId,
                                content: "Congratulations! You were " + part.attentiveness.toString() + "% focused on your last lecture! That's the way to do it!",
                                mine: true,
                                show: (this.props.profile.settings.shareScore) ? true : false
                            }

                            this.props.createCourseNotification(note, this.props.user.id);
                        }
                    }catch(err){
                        //// console.log("Notification creation failed with", err);
                    }
                    
                    let meritTable = [
                        -6
                        -5,
                        -4,
                        -3,
                        -2,
                        -1,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ]

                    let merits = {
                        quiz: [
                            {
                                min: 0,
                                max: 50,
                                points: -30
                            },
                            {
                                min: 50,
                                max: 70,
                                points: -30
                            },
                            {
                                min: 70,
                                max: 80,
                                points: -30
                            },
                            {
                                min: 80,
                                max: 90,
                                points: 25
                            },
                            {
                                min: 90,
                                max: 95,
                                points: 50
                            },
                            {
                                min: 95,
                                max: 1000,
                                points: 75
                            }
                        ],
                        attentiveness: [
                            {
                                min: 0,
                                max: 50,
                                points: -50
                            },
                            {
                                min: 50,
                                max: 70,
                                points: -25
                            },
                            {
                                min: 70,
                                max: 80,
                                points: -10
                            },
                            {
                                min: 80,
                                max: 90,
                                points: 10
                            },
                            {
                                min: 90,
                                max: 95,
                                points: 35
                            },
                            {
                                min: 95,
                                max: 1000,
                                points: 70
                            }
                        ],
                        efficiency: [
                            {
                                min: 0,
                                max: 50,
                                points: -10
                            },
                            {
                                min: 50,
                                max: 70,
                                points: 0
                            },
                            {
                                min: 70,
                                max: 80,
                                points: 10
                            },
                            {
                                min: 80,
                                max: 90,
                                points: 15
                            },
                            {
                                min: 90,
                                max: 95,
                                points: 20
                            },
                            {
                                min: 95,
                                max: 1000,
                                points: 25
                            }
                        ],
                        singleAttempt: [-25, 25]
                    }
                    
                    let completion = part.attentiveness;
                    completion += part.efficiency > 100 ? 100 : part.efficiency;
                    completion += ((part.duration / part.userTime) * 100) > 100 ? 100 : ((part.duration / part.userTime) * 100);
                    let totalCompletion = 300;
                    if(this.props.quiz.correctPercent){
                        completion += this.props.quiz.correctPercent;
                        totalCompletion += 100;
                    }
                    

                    let points = {
                        quiz: 0,
                        attentiveness: 0,
                        efficiency: 0,
                        completion: 0
                    }

                    Object.keys(points).map(k => {
                        if(k === "completion"){
                            if(this.props.userLecture.attempts === 1){
                                points[k] = 25;
                            }else{
                                points[k] = -25;
                            }
                        }else if(k === "quiz"){
                            if(this.props.quiz.correctPercent){
                                let pc = this.props.quiz.correctPercent;
                                let pointObject = merits[k].filter(p => pc > p.min && pc < p.max);
                                if(pointObject.length > 0){
                                    points[k] = pointObject[0].points;
                                }
                            }
                        }else{
                            let pointObject = merits[k].filter(p => part[k] > p.min && part[k] < p.max);
                            if(pointObject.length > 0){
                                points[k] = pointObject[0].points;
                            }
                        }
                    })

                    let totalPoints = 0;
                    Object.keys(points).map(p => {
                        totalPoints += points[p];
                    });
                    
                    let newPart = {
                        ...part,
                        completion: Math.ceil((completion / totalCompletion) * 100),
                        subjectChapterId: part.subjectChapterId,
                        quiz: this.props.quiz.correctPercent ? this.props.quiz.correctPercent : 0,
                        points: points,
                        totalPoints: totalPoints,
                        completed: true,
                        userSubjectId: part.userSubjectId || this.props.userSubject.id
                    };
                    

                    
                    courseUser.points += totalPoints;
                    courseUser.attempts = 1;
                    
                    
                    // itempercent / 10


                    // Push completed Chapter Part to courseUser, and reset some properties
                    // courseUser.completedChapterParts.push(newPart);
                    // DO NOT push to completedChapter Parts.  instead, call update userLecture
                    let self = this;

                    const newHourlyStat = {
                        courseId: newPart.courseId,
                        result: newPart.attentiveness,
                        type: "attentiveness",
                        statType: "hourly",
                        persistent: false,
                        totalScores: 0,
                        totalItems: 0
                    };

                    const newStat = {
                        courseId: newPart.courseId,
                        result: newPart.attentiveness,
                        type: "attentiveness",
                        statType: "daily",
                        persistent: false,
                        totalScores: 0,
                        totalItems: 0
                    };

                    this.props.sendStat(newStat, this.props.user.id);
                    this.props.sendStat(newHourlyStat, this.props.user.id);

                    this.props.updateUserLecture(newPart, this.props.user.id, () => {
                        courseUser.currentUserTime = null;
                        courseUser.currentPartVideoTime = null;
                        


                        // Prepare to find current and next steps
                        let currentChapter = {};
                        let nextChapterPart = {};
                        let nextChapter = {};
                        let nextSubject = {};

                        

                        self.props.nextChapterPart(courseUser, self.props.user.id);
                        self.props.getSyllabus(courseUser.id);
                    });

                    
                    //NotificationManager.success("You may now proceed to the next video", "Congratulations!");
                    
                }
            })
        }
    }

    answerSuccess = () => {
        this.setState({
            count: this.state.count+1,
            showQuestion: false
        });

        // Continue video
        this.videoContainer.current.play();
    }

    checkModalAnswerOption = (index) => {
        this.setState({
            currentModalOptionIndex: index
        })
    };

    playAnswerSound = () => {
        this.audioSource.play();
    };



    renderQuizes = () => {
        let completed = [];
        
        if(this.props.courseUser[0]){
            if(this.props.ul){
                completed = this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active);
            }
        }
        return (
            <div className="nav-tabs-custom">
            <ul className="nav nav-tabs" id="quizTabs">
                {
                    this.props.chapterPart.VideoQuestions &&
                    this.props.chapterPart.VideoQuestions.length > 0 &&
                    <li>
                        <a
                            href="#video_question_summary"
                            data-toggle="tab"
                        >
                            {this.props.videoQuestions.filter(q => q.correct === true).length >= this.props.chapterPart.VideoQuestions.length &&
                                <span><i className="text-success zmdi zmdi-check" /> &nbsp;</span>
                            }
                            Summary
                        </a>
                    </li>
                }
                {this.props.chapterPart.QuizQuestions &&
                this.props.chapterPart.QuizQuestions.length > 0 &&
                <li>
                    <a
                        href="#final_quiz"
                        data-toggle="tab"
                        disabled={!this.state.showQuiz}
                    >
                    {this.props.quiz.id && this.props.quiz.completed ?
                                <span><i className="text-success zmdi zmdi-check" /> &nbsp;</span>
                            : null}
                        Lecture Quiz
                    </a>
                </li>
                }
            {this.props.chapterPart.VideoQuestions && this.props.chapterPart.QuizQuestions ?
                <li 
                >
                    <a
                        href="#video_discussion"
                        data-toggle="tab"
                    >

                        Discussion
                    </a>
                </li>
                : null}
            </ul>

            <div className="tab-content no-padding">
                {this.props.chapterPart.VideoQuestions &&
                this.props.chapterPart.VideoQuestions.length > 0 &&
                <VideoQuestionSummary
                    videoQuestionSummery={this.props.videoQuestionSummery}
                    videoQuestions={this.props.videoQuestions ? this.props.videoQuestions : []}
                    fullQuestions={this.props.chapterPart.VideoQuestions}
                    updateVideoQuestion={this.props.updateVideoQuestion}
                />
                }
                <VideoDiscussion
                    discussion={this.props.discussion || []}
                    onPost={(comment) => {
                        //this.props.postComment(comment, this.props.user.user, this.props.user.id)
                        let discussion = {
                            type: 'ADD_DISCUSSION',
                            profileId: this.props.profile.id,
                            discussion: comment
                        }
                        send(discussion, this.props.socket, this.props.user.id);
                    }}
                    onPostComment={(comment) => {
                        //this.props.postComment(comment, this.props.user.user, this.props.user.id)
                        let discussion = {
                            type: 'ADD_COMMENT',
                            profileId: this.props.profile.id,
                            discussion: comment
                        }
                        send(discussion, this.props.socket, this.props.user.id);
                    }}
                    postLike={(like) => {
                        let item = {
                            type: 'ADD_LIKE',
                            like: like,
                            videoId: this.props.match.params.id
                        }
                        send(item, this.props.socket, this.props.user.id);
                    }}
                    deleteLike={(like) => {
                        let item = {
                            type: 'REMOVE_LIKE',
                            profileId: this.props.profile.id,
                            like: like,
                            videoId: this.props.match.params.id
                        }
                        send(item, this.props.socket, this.props.user.id);
                    }}
                    postFollow={(follow) => {
                        let item = {
                            type: 'ADD_FOLLOW',
                            follow: follow,
                            videoId: this.props.match.params.id
                        }
                        send(item, this.props.socket, this.props.user.id);
                    }}
                    deleteFollow={(follow) => {
                        let item = {
                            type: 'REMOVE_FOLLOW',
                            profileId: this.props.profile.id,
                            follow: follow,
                            videoId: this.props.match.params.id
                        }
                        send(item, this.props.socket, this.props.user.id);
                    }}
                    user={this.props.user}
                    chapterVideoId={this.props.chapterPart.id}
                    showByDefault={false}
                />

                {this.props.chapterPart.QuizQuestions &&
                this.props.chapterPart.QuizQuestions.length > 0 &&
                <div className={"tab-pane"}
                     id="final_quiz"
                >
                    {this.state.showQuiz || completed.length > 0 ?
                        <FinalQuiz
                            questions={this.props.chapterPart.QuizQuestions}
                            courseUser={this.props.courseUser[0]}
                            quiz={this.props.quiz}
                            scoreTest={(test) => {
                                if(this.props.profile.role === "student"){
                                    test.courseUserId = this.props.courseUser[0].id;
                                    this.props.scoreTest(this.props.quiz.id, this.props.user.id);
                                }else{
                                    this.props.fakeScoreTest(this.props.quiz.id, this.props.user.id);
                                }
                                //this.updateCourseUserNextVideo();
                            }}
                            getOrCreate={() => {
                                this.props.getOrMakeQuiz(this.props.userLecture.id, this.props.user.id);
                            }}
                            updateQuiz={(question, mode) => {
                                this.props.addQuizQuestion(this.props.quiz.id, question, mode, this.props.user.id);
                            }}
                            updateCurrentQuestion={(mode, t) => {
                                this.props.updateCurrentQuestion(this.props.quiz.id, mode, t, this.props.user.id);
                            }}
                            retakeQuiz={() => {

                            }}
                            user={this.props.user}
                            chapterPart={this.props.chapterPart}
                            results={(this.props.quiz) ? this.props.quiz : {}}
                            show={this.state.showQuiz}
                            userLecture={this.props.userLecture}
                        />
                        : <h1 className="panel-text">You must complete the video before proceeding to the lecture quiz</h1>
                    }

                </div>
                }
                <div className="tab-pane" id="discussion">
                </div>
            </div>
        </div>
        )
    }

    renderAudioSource = () => (
        <div>
            <audio
                ref={(audio) => this.audioSource = audio}
            >
                <source src={correctSound} type="audio/wav"/>
                Your browser does not support the audio element.
            </audio>
        </div>
    );

    componentWillUnmount(){
        let {currentLog} = this.props;
        if(currentLog){
            currentLog.end = new Date();
            this.props.updateLog(currentLog, this.props.user.id);
        }
    }

    onVideoQuestionsComplete = () => {
        if(!this.state.completedComponents.questions){
            // They've completed all the video questions, set the flag
            let {completedComponents} = this.state;
            let newComponents = {
                ...completedComponents,
                questions: true
            };
            
            this.setState({completedComponents: newComponents});
        }
    }

    onQuizComplete = () => {
        if(this.props.chapterPart.QuizQuestions){
            if(!this.state.completedComponents.quiz && this.props.chapterPart.QuizQuestions.length > 0){
                // They've completed all the video questions, set the flag
                let {completedComponents} = this.state;
                let newComponents = {
                    ...completedComponents,
                    quiz: true
                };
                let {currentLog} = this.props;
                if(currentLog){
                    currentLog.end = new Date();
                    currentLog.score = this.props.quiz.correctPercent;
                    this.props.updateLog(currentLog, this.props.user.id);
                }
                
                this.setState({completedComponents: newComponents});
            }
        }
    }
    
    onVideoComplete = () => {
        if(!this.state.completedComponents.video){
            // They've completed all the video questions, set the flag
            let {completedComponents} = this.state;
            let newComponents = {
                ...completedComponents,
                video: true
            };
            
            this.setState({completedComponents: newComponents});
        }
    }

    onVideoCompleteOld = () => {

        if (this.props.chapterPart.VideoQuestions.length == 0 && this.props.chapterPart.QuizQuestions.length == 0) {
                    if(!this.state.markedNext) {
                        this.updateCourseUserNextVideo();
                    }

                } else if (this.props.chapterPart.QuizQuestions.length == 0) {
                    if(!this.state.markedNext) {
                        this.updateCourseUserNextVideo();
                    }
                } else {
                    if(!this.state.markedShowQuiz) {
                        this.setState({markedShowQuiz: true}, () => {
                            
                            if(this.props.quiz.id){
                                if(this.props.quiz.correctPercent >= 80){
                                    if(this.props.courseUser[0].role != "demo"){
                                        this.updateCourseUserNextVideo();
                                    }
                                }else{
                                    NotificationManager.success('To proceed, please take the final test for this lecture.', 'Awesome job finishing this lecture!');
                                    $('[href="#final_quiz"]').tab('show');
                                    window.scroll({
                                      top: document.getElementsByClassName('nav-tabs-custom')[0].scrollHeight, 
                                      left: 0, 
                                      behavior: 'smooth' 
                                    });
                            
                                }
                            }else{
                                NotificationManager.success('To proceed, please take the final test for this lecture.', 'Awesome job finishing this lecture!');
                                $('[href="#final_quiz"]').tab('show');
                                window.scroll({
                                  top: document.getElementsByClassName('nav-tabs-custom')[0].scrollHeight, 
                                  left: 0, 
                                  behavior: 'smooth' 
                                });
                            }
                            this.setState({
                                showQuiz: true
                            });
                        });
                    }
            }
    }
    
    showVideoQuestion = (frameQuestions) => {
        if(JSON.stringify(frameQuestions) !== JSON.stringify(this.state.frameQuestions)){
            this.setState({
                show: true,
                showQuestion: true,
                showReadOnlyQuestion: false,
                frameQuestions: frameQuestions
            });
        }
    }

    getCurrentTime = () => {
        if(this.videoContainer.current){
            return this.videoContainer.current.state.currentTime;
        }else{
            return -1;
        }
    }

    render() {
        // MOVE IT TO CONNECT

        if(this.props.courseUser[0] && this.props.profile.role === "student"){
            if(this.props.courseUser[0].status !== "approved" || this.props.canView === 'no'){
                return (
                    <div><h1 className="expired-content">You do not have access to this content.  Please contact your instructor if you feel this is in error.</h1></div>
    
                )
            }
        }

        if(this.props.canView === 'no' && this.props.profile.role === 'student'){
            return (
                <div><h1 className="expired-content">You do not have access to this content.  Please contact your instructor if you feel this is in error.</h1></div>

            )
        }
        
         

        let marks = [];

        if(this.props.chapterVideo){
            this.props.chapterVideo.VideoQuestions.map((v, i) => {
                return marks.push(i);
            })
        }

        if(this.props.loading || !this.props.userLecture){
            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )
        }

        if(this.props.courseUser[0] && this.props.profile.role === "student"){
            if(!this.props.chapterPart){
                return (
                    <div className="loader">
                        <div className="sk-folding-cube">
                            <div className="sk-cube1 sk-cube"></div>
                            <div className="sk-cube2 sk-cube"></div>
                            <div className="sk-cube4 sk-cube"></div>
                            <div className="sk-cube3 sk-cube"></div>
                        </div>
                    </div>
                )
            }else if(this.props.chapterPart.id){
                if(
                    this.props.ul.filter(p => p.chapterVideoId === this.props.chapterPart.id && p.completed === true).length === 0 &&
                    this.props.courseUser[0].currentChapterPart !== this.props.chapterPart.id &&
                    this.props.courseUser[0].nextChapterPart.id !== this.props.chapterPart.id && !this.props.userLecture.active){
                    return (
                        <div><h1 className="expired-content inaccessible">You do not have access to this content.  Please contact your instructor if you feel this is in error.</h1></div>
        
                    )
                    }
            } 
            
        }
        
       

        let seconds = parseInt(this.state.userTime % 60);
        let timer = (seconds < 10) ? parseInt(this.state.userTime / 60) + ":" + "0" + seconds.toString()
            : parseInt(this.state.userTime / 60) + ":" + seconds.toString();

        let alreadyCompleted = [];
        
        if(this.props.courseUser[0]){
            if(this.props.ul){
                alreadyCompleted = this.props.ul.filter(l =>  l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active);
            }
        }

        let part = this.props.userLecture;


        return (
            <div className="content-wrapper">
                {
                    this.state.nextChapterPart.id !== this.props.chapterPart.id && this.state.markedNext &&
                        this.state.showNextVideo && part && this.state.loaded &&
                        
                        <VideoScore
                            completedIn={part.userTime}
                            videoTime={part.duration}
                            efficiency={part.efficiency}
                            attentiveness={part.attentiveness}
                            quiz={this.props.userLecture.Lecture.QuizQuestions.length > 0 ? part.quiz : -1}
                            completion={part.completion}
                            completedPoints={part.points.completed}
                            efficiencyPoints={part.points.efficiency}
                            attentivenessPoints={part.points.attentiveness}
                            quizPoints={part.points.quiz}
                            completionPoints={part.points.completion}
                            totalPoints={Number(this.props.courseUser[0].points)}
                            profile={this.props.profile}
                            courseUser={this.props.courseUser[0]}
                            user={this.props.user}
                            feedbackPrompt={this.props.chapterPart.feedbackPrompt || false}
                            finishedSubject={this.state.finishedSubject}
                            onContinue={e => {
                                e.preventDefault();
                                let ncp = this.props.courseUser[0].nextChapterPart;
                                let finishedSubject = this.state.finishedSubject;
                                this.setState({
                                requiredComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: true
                                },
                                completedComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: false
                                },
                                count: 0,
                                videoId: null,
                                showQuiz: false,
                                showSummaryAndStuff: true,
                                showNextVideo: false,
                                markedShowQuiz: false,
                                markedNext: false,
                                nextChapterPart: {},
                                frameQuestions: [],
                                finishedSubject: false,
                                completed: false,
                                loaded: false,
                                showingScore: false,
                                idleModal: false,
                                }, () => {
                                    let self = this;
                                        if(finishedSubject){
                                            self.props.history.push('/dashboard');
                                        }else{
                                                if(ncp.type == "test"){
                                                self.props.history.push('/subject-test/' + ncp.id)
                                            }else{
                                                self.props.history.push('/video/item/' + ncp.id)
                                            } 
                                        }
                                    
                                    
                                }) 
                                
                            }}
                            continueLink={(<Link to="#nogo" onClick={e => {
                                e.preventDefault();
                                let ncp = this.props.courseUser[0].nextChapterPart;
                                this.setState({
                                requiredComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: true
                                },
                                completedComponents: {
                                    questions: false,
                                    quiz: false,
                                    video: false
                                },
                                count: 0,
                                videoId: null,
                                showQuiz: false,
                                showSummaryAndStuff: true,
                                showNextVideo: false,
                                markedShowQuiz: false,
                                markedNext: false,
                                nextChapterPart: {},
                                frameQuestions: [],
                                finishedSubject: false,
                                completed: false,
                                loaded: false,
                                showingScore: false,
                                idleModal: false,
                                }, () =>{
                                    let self = this;
                                        if(self.state.finishedSubject){
                                            self.props.history.push('/dashboard');
                                        }else{
                                                if(ncp.type == "test"){
                                                self.props.history.push('/subject-test/' + ncp.id)
                                            }else{
                                                self.props.history.push('/video/item/' + ncp.id)
                                            } 
                                        }
                                    
                                    
                                }) 
                                
                            }} className="btn btn-primary" style={{margin: '60px'}}>Continue <i className="zmdi zmdi-arrow-right" /></Link>)}
                        />
                    }
                <section className="content">
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={1000 * 300} />
                <audio
                    id="successSound"
                    controls={false}
                    src={successAudio}>
                    Your browser does not support the <code>audio</code> element.
                </audio>
                    {this.props.userLecture &&
                        
                        <LectureTimer
                            ref={this.timer}
                            idle={this.state.idleModal}
                            completed={this.state.completed}
                            show={(this.state.loaded)}
                            startTime={this.props.userLecture.userTime}
                            courseUser={this.props.courseUser[0]}
                            currentTime={this.getCurrentTime}
                            getCurrentDuration={this.getCurrentDuration}
                            syncTaskProgress={this.syncTaskProgress}
                            syncVideoTime={(courseUser, userLecture, token) => {
                                if(this.props.quiz){
                                    if(this.props.quiz.correctPercent < 80){

                                    }else{
                                        userLecture = {
                                            ...userLecture,
                                            userSubjectId: userLecture.userSubjectId || this.props.userSubject.id
                                        }
                                        this.props.syncVideoTime(courseUser, userLecture, token);
                                    }
                                }
                            }}
                            user={this.props.user}
                            lectureId={this.props.chapterPart.id}
                            userLecture={this.props.userLecture}
                        />
                    }


                    <div className="row">
                        <div className="col-sm-12">
                            {this.state.idleModal ?
                                <IdleModal
                                    continue={e => this.setState({idleModal: false})}
                                    view={'lecture'}
                                />
                                : null
                            }

                            <VideoQuestion
                                ref={this.question}
                                totalQuestions={this.props.chapterPart.VideoQuestions ? this.props.chapterPart.VideoQuestions.length : 0}
                                frameQuestions={this.state.frameQuestions}
                                setThrowforward={this.setThrowforward}
                                setThrowback={this.setThrowback}
                                updateVideoQuestion={(question, token) => this.updateVideoQuestion(question, token)}
                                videoQuestions={this.props.videoQuestions}
                                user={this.props.user}
                                onFinish={() => this.onVideoQuestionsComplete()}
                                qi={this.state.count + 1}
                                userLecture={this.props.userLecture}
                            />
                            
                            {this.props.chapterPart.VideoFile &&
                                <VideoPlayer
                                    ref={this.videoContainer}
                                    videoFile={this.props.chapterPart.VideoFile.length > 0 ? this.props.chapterPart.VideoFile[0] : {}}
                                    courseUser={this.props.courseUser[0]}
                                    profile={this.props.profile}
                                    userVideoQuestions={this.props.videoQuestions}
                                    fullVideoQuestions={this.props.chapterPart.VideoQuestions}
                                    marks={marks}
                                    completed={false}
                                    onFinish={() => this.onVideoComplete()}
                                    showVideoQuestion={(frameQuestions) => this.showVideoQuestion(frameQuestions)}
                                    user={this.props.user}
                                    chapterPart={this.props.chapterPart}
                                    count={this.state.count}
                                    userLecture={this.props.userLecture}
                                />
                            }
                        </div>
                    </div>
                    <div className="row">
                        {this.props.chapterPart &&
                            this.props.chapterPart.VideoQuestions ?
                            <div className={`${this.props.chapterPart.VideoQuestions.length > 0 ? 'col-sm-12' : 'col-sm-12'}`}>
                                {
                                    this.state.showSummaryAndStuff && this.props.chapterPart
                                    && this.renderQuizes()
                                }
                            </div>
                            : null
                        }
                        { /*this.props.chapterPart &&
                            this.props.chapterPart.VideoQuestions.filter(q => q.name).length > 0 &&
                                <LectureObjectives
                                    lectureObjectives={this.props.lectureObjectives}
                                    objectives={this.props.chapterPart.VideoQuestions.filter(q => q.name)}
                                    userQuestions={this.props.videoQuestions}
        
                                />*/
                        }
                    </div>
                    {this.renderAudioSource()}

                </section>
            </div>
        );
    }
}

export default VideoItem;


// WEBPACK FOOTER //
// ./src/components/Video/VideoItem.js